// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import AffectedPin from './affected-pin';
import PipRequiredItem from './pip-required-item';
import t from 'tcomb';

const PipDetails = t.struct({
    affectedPins: t.list(AffectedPin, 'AffectedPins'),
    comments: t.String,
    daysLeft: t.Number,
    description: t.String,
    dtac: t.String,
    dtacUrl: t.String,
    expireDate: t.Number,
    internalRecall: t.String,
    metric: KeyValuePair,
    nonSerialized: t.Boolean,
    participant: KeyValuePair,
    pipId: t.String,
    pipNumber: t.String,
    pipStatus: KeyValuePair,
    pipType: KeyValuePair,
    requiredItems: t.list(PipRequiredItem, 'PipRequiredItems'),
    specialInstructions: t.String,
    startDate: t.Number,
    statusReason: t.String,
    terminationDate: t.Number
}, {
    name: 'PipDetails',
    strict: true
});

export const getDefaultState = () => new PipDetails({
    affectedPins: [],
    comments: '',
    daysLeft: -1,
    description: '',
    dtac: '',
    dtacUrl: '',
    expireDate: 0,
    internalRecall: '',
    metric: getKeyValuePairDefaultState(),
    nonSerialized: false,
    participant: getKeyValuePairDefaultState(),
    pipId: '',
    pipNumber: '',
    pipStatus: getKeyValuePairDefaultState(),
    pipType: getKeyValuePairDefaultState(),
    requiredItems: [],
    specialInstructions: '',
    startDate: 0,
    statusReason: '',
    terminationDate: 0
});

export default PipDetails;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pip-details.js